import { ActionTypes } from '../../constants/ActionTypes';
import { IArchiveFolderList, IDmsResponse } from '../../interfaces/Dms/Dms';

export const onGetDmsList = (
  pageSize: number,
  folder: string,
  pageNumber: number,
  search: string,
  isDelete: boolean,
  isExpire: boolean | null,
) => {
  return {
    type: ActionTypes.GET_DMS_LIST,
    payload: {
      pageSize: pageSize,
      folder: folder,
      pageNumber: pageNumber,
      search: search,
      isDelete: isDelete,
      isExpire: isExpire,
    },
  };
};
export const onGetDmsListSuccess = (action: IDmsResponse) => {
  return {
    type: ActionTypes.GET_DMS_LIST_SUCCESS,
    payload: action,
  };
};

export const onGetFullDmsList = (
  pageNumber: number,
  search?: string,
  code?: string,
  id?: number | null,
) => {
  return {
    type: ActionTypes.GET_DMS_FULL_LIST,
    payload: {
      pageNumber: pageNumber,
      search: search,
      code: code,
      id: id,
    },
  };
};

export const onGetFullDmsListSuccess = (action: IArchiveFolderList[]) => {
  return {
    type: ActionTypes.GET_DMS_LIST_FULL_SUCCESS,
    payload: { archiveFolderList: action },
  };
};
